import React from "react";
import snakeCase from "lodash/snakeCase";
import camelCase from "lodash/camelCase";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import labels from "../../constants/displayFields";
import Input from "../../components/form/Input";
import DestinationRoomNumbersScrubber from "./DestinationRoomNumbers/DestinationRoomNumbersScrubber";
import DestinationRoomNumbersCapture from "./DestinationRoomNumbers/DestinationRoomNumbersCapture";

const nameField = name => camelCase(name);

const DESTINATION_STRING_FIELDS = [
  "newBuilding",
  "newRoom",
  "newFloor",
  "destinationEmployeeName",
  "destinationComments",
];

export default function FieldsDestination({ display, type, asset, disabledForm }) {
  const buildFields = fields =>
    fields.reduce((result, key) => {
      const displayField = display[snakeCase(key)];
      return displayField ? [...result, snakeCase(key)] : result;
    }, []);

  const displaySection =
    display.new_building ||
    display.new_room ||
    display.new_floor ||
    display.destination_room_number ||
    display.destination_employee_name ||
    display.destination_comments ||
    display.destination_quantity ||
    display.destination_number ||
    display.install_responsibility;

  return displaySection ? (
    <Card style={{ overflow: "visible" }}>
      <CardContent>
        <Box mt={-1}>
          <Typography fontWeight={500} fontSize={18}>
            Destination
          </Typography>
        </Box>
        <Grid container spacing={1.5}>
          {buildFields(DESTINATION_STRING_FIELDS).map((fieldKey, index) => (
            <Grid key={`field-${index}`} size={12}>
              <Input
                type="autoExpand"
                name={nameField(fieldKey)}
                label={labels[fieldKey]}
                disabled={disabledForm}
              />
            </Grid>
          ))}
          {display.destination_room_number && (
            <Grid size={12}>
              {type === "scrubber" ? (
                <DestinationRoomNumbersScrubber
                  type={type}
                  entity={asset}
                  disabled={disabledForm}
                />
              ) : (
                <DestinationRoomNumbersCapture
                  type={type}
                  entity={asset}
                  disabled={disabledForm}
                />
              )}
            </Grid>
          )}
          {display.destination_quantity && (
            <Grid size={12}>
              <Input
                type="number"
                name={nameField("destination_quantity")}
                label={labels.destination_quantity}
                disabled={disabledForm}
                showNAButton={false}
              />
            </Grid>
          )}
          {display.destination_number && (
            <Grid size={12}>
              <Input
                type="autoExpand"
                name={nameField("destination_number")}
                label={labels.destination_number}
                disabled={disabledForm}
              />
            </Grid>
          )}
          {display.install_responsibility && (
            <Grid size={12}>
              <Input
                type="autoExpand"
                name={nameField("install_responsibility")}
                label={labels.install_responsibility}
                disabled={disabledForm}
              />
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  ) : null;
}
